import { render, staticRenderFns } from "./Nes.vue?vue&type=template&id=455edff0&"
import script from "./Nes.vue?vue&type=script&lang=js&"
export * from "./Nes.vue?vue&type=script&lang=js&"
import style0 from "./Nes.vue?vue&type=style&index=0&id=455edff0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports